import { FetchStatus, Property, PropertyType } from "../../../../../base/types";
import { useEffect, useState } from "react";

import { IAsyncBoundProperties } from "../../../../../base/hooks";
import { ITextAreaProps } from "./ITextAreaProps";

export const TextAreaProperties = [
    { id: Property.Label, name: 'Label', type: PropertyType.String },
    { id: Property.InitValue, name: 'Value', type: PropertyType.String },
    { id: Property.Placeholder, name: 'Placeholder', type: PropertyType.String },
    { id: Property.Required, name: 'Required', type: PropertyType.Boolean },
    { id: Property.Readonly, name: 'Readonly', type: PropertyType.Boolean },
    { id: Property.Disabled, name: 'Disabled', type: PropertyType.Boolean },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String },
    { id: Property.Min, name: 'Min. Length', type: PropertyType.Number },
    { id: Property.Max, name: 'Max. Length', type: PropertyType.Number },
    { id: Property.RegExPattern, name: 'RegEx Pattern', type: PropertyType.String },
]

export const useTextAreaProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<ITextAreaProps>()

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        const attributes: ITextAreaProps = {
            label: bindings.getValue(Property.Label) || '',
            title: bindings.getValue(Property.Tooltip) || '',
            placeholder: bindings.getValue(Property.Placeholder) || '',
            value: bindings.getValue(Property.InitValue) || '',
            required: bindings.getValue(Property.Required) || false,
            readOnly: bindings.getValue(Property.Readonly) || false,
            disabled: bindings.getValue(Property.Disabled) || false,
            minLength: bindings.getValue(Property.Min),
            maxLength: bindings.getValue(Property.Max),
            regEx: bindings.getValue(Property.RegExPattern)
        };

        setProperties(attributes)
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties }
}
